import request from '@/utils/request'
// 新版绩效获取绩效详情
export function getDetail20240527(data) {
  return request({
      url: '/backend/employee/performance/getDetail20240527',
      method: 'post',
      data: data
  })
}
// 暂存草稿或提交绩效
export function saveData20240527(data) {
  return request({
      url: '/backend/employee/performance/saveData20240527',
      method: 'post',
      data: data
  })
}
// 上级确认或驳回绩效目标
export function dealGoalStage(data) {
  return request({
      url: '/backend/employee/performance/dealGoalStage',
      method: 'post',
      data: data
  })
}
// 获取评语
export function getCommentList(data) { 
  return request({
      url: '/backend/employee/performance/getCommentList',
      method: 'post',
      data: data
  })
}
// 提交评语
export function saveCommentData(data) { 
  return request({
      url: '/backend/employee/performance/saveCommentData',
      method: 'post',
      data: data
  })
}

// 获取绩效指标库
export function getPerformanceGoal(data) {
  return request({
      url: '/backend/employee/performance/getPerformanceGoal',
      method: 'post',
      data: data
  })
}